import { render, staticRenderFns } from "./PelletsPriceDisplay.vue?vue&type=template&id=2b31cc8d"
import script from "./PelletsPriceDisplay.vue?vue&type=script&lang=ts"
export * from "./PelletsPriceDisplay.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports